var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.rowSpacing},[_c('fieldset',[_c('div',{class:_vm.$style.flexRow},[_c('CheckboxWithLabel',{attrs:{"label":_vm.sudoLabel,"name":"sudo","tooltip":{
          kbLink: _vm.sudoKbLink,
          text: _vm.$options.tooltip.sudo.text,
        },"value":_vm.sudoValue},on:{"change":_vm.handleSudoChange}})],1)]),_c('fieldset',{class:[_vm.passwordlessSudoClassName, _vm.$style.revealedRow]},[_c('div',{class:_vm.$style.flexRow},[_c('CheckboxWithLabel',{attrs:{"label":_vm.passwordlessSudoLabel,"name":"passwordless_sudo","tooltip":{
          text: _vm.$options.tooltip.passwordless_sudo.text,
        },"value":_vm.passwordlessSudoValue},on:{"change":_vm.handleValueChange}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }